const Colors = {
  /** brand/success */
  Pri10: '#fffed6',
  Pri40: '#fffb8f',
  Pri70: '#fff947',
  Pri100: '#fff700',
  Pri110: '#c2b500',
  Pri140: '#857700',
  Pri170: '#473e00',

  /** brand/link */
  Sec10: '#d7f5e6',
  Sec40: '#b6e0cb',
  Sec70: '#6ccc9c',
  Sec100: '#2eb873',
  Sec110: '#157a44',
  Sec140: '#063d1e',
  Sec170: '#001F0C',

  /** warning */
  Y10: '#fff1d6',
  Y40: '#ffda8f',
  Y70: '#ffc247',
  Y100: '#ffaa00',
  Y110: '#c27b00',
  Y140: '#855000',
  Y170: '#472800',

  /** danger */
  R10: '#ffe4e0',
  R40: '#ffcac2',
  R70: '#ff8c7a',
  R100: '#ff4e33',
  R110: '#c22817',
  R140: '#850e05',
  R170: '#470200',

  /** safe */
  B10: '#d6f0ff',
  B40: '#8fd6ff',
  B70: '#47bcff',
  B100: '#00a2ff',
  B110: '#0081c2',
  B140: '#005d85',
  B170: '#003447',

  I10: '#e0e0ff',
  I40: '#ccccff',
  I70: '#8585ff',
  I100: '#3d3dff',
  I110: '#1f24c2',
  I140: '#0b1385',
  I170: '#000747',

  /** pink color */
  P10: '#FEE0EA',
  P40: '#FEB9D0',
  P70: '#FE72A1',
  P100: '#FE2C64',
  P110: '#C21152',
  P140: '#850136',
  P170: '#47001F',

  /** neutral color */

  /** Black with Alpha */
  N100_10: 'rgba(0, 0, 0, .1)',
  N100_20: 'rgba(0, 0, 0, .2)',
  N100_40: 'rgba(0, 0, 0, .4)',
  N100_60: 'rgba(0, 0, 0, .6)',
  N100_90: 'rgba(0, 0, 0, .9)',
  N100: '#000000',

  // White with Alpha
  N00_10: 'rgba(255, 255, 255, .1)',
  N00_20: 'rgba(255, 255, 255, .15)',
  N00_40: 'rgba(255, 255, 255, .3)',
  N00_60: 'rgba(255, 255, 255, .6)',
  N00_90: 'rgba(255, 255, 255, .9)',
  N00: '#FFFFFF',

  // Background Color
  BG01: '#F7F7F7',
  BG02: '#F2F2F2',
  BG03: '#1A1A1A',
  BG04: '#333333'
}

export * from './ladder_color'
export { Colors }
